import React from 'react'
import styled from '@emotion/styled'

import vioGif from './vio.gif'

type Size = 'sm' | 'md' | 'lg'

interface Props {
  size?: Size
}

const sizesMap = {
  sm: 22,
  md: 44,
  lg: 88
}
const Wrapper = styled.div<{size: Size}>`
  height: ${({size}) => `${sizesMap[size]}px`};
  display: flex;
  justify-content: center;
  align-items: center;
`
export const AnimatedLogo = ({size = 'md'}: Props) => {
  return (
    <Wrapper size={size}>
      <img src={vioGif} width={sizesMap[size]} alt="vio-logo-gif" />
    </Wrapper>
  )
}
